export default __webpack_public_path__ + "static/media/ObviouslyRegular.a1c58ec9.otf";